import { environment as defaultEnvironment } from './environment.default';

export const environment = {
  ...defaultEnvironment,
  production: true,
  apiBaseUrl: 'https://qualityapi.linq-modular.com',
};
